import * as React from 'react';

import { useTranslations } from '@rematter/modules/trade/i18n/useTranslations';
import { IconButton } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';
import { LucideExternalLink } from 'lucide-react';

import { $openCatalyticModal } from '../../../../_state/loadStaged.state';
import { LoadStagedFieldProps } from '../_types';

export const EditItemButtonField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  disabled,
  onFocus,
  onBlur,
}) => {
  const t = useTranslations();
  const openCatalyticModal = useSetAtom($openCatalyticModal);

  const handleCatalyticPress = React.useCallback(() => {
    openCatalyticModal({
      mode: 'edit',
      selectedItemId: lineItem.itemId ?? null,
      lineItemId: lineItem.id,
    });
  }, [openCatalyticModal, lineItem.itemId, lineItem.id]);

  return (
    <div onFocus={onFocus} onBlur={onBlur} className="@EditItemButtonField">
      <IconButton
        icon={<LucideExternalLink size={18} className="text-neutral/60" />}
        className="@DeleteButton size-input h-full"
        variant="ghost"
        color="neutral"
        onPress={handleCatalyticPress}
        aria-label={t.loadStaged.placeholders.editCatalyticConverter}
        isDisabled={disabled}
      />
    </div>
  );
};
